import {useCallback, useContext} from 'react'
import type {PreloadedQuery} from 'react-relay/relay-hooks/EntryPointTypes'
import type {ScrollParams} from 'react-virtualized/dist/es/Grid'

import {useRefetchablePreloadedQuery} from '../../../../../../hooks/relay/useRefetchablePreloadedQuery'
import SidebarPanelContentNoResults from '../../SidebarPanelContentNoResults/SidebarPanelContentNoResults'
import type {QueueSidebarQuery} from '../__generated__/QueueSidebarQuery.graphql'
import {QueueSidebarSearchContext} from '../QueueSidebar.contexts'
import {useQueueSidebarItems, useSubscribeOnPoolCounters} from '../QueueSidebar.hooks'
import {query} from '../QueueSidebar.queries'

import QueueSidebarItems from './QueueSidebarItems/QueueSidebarItems'

import styles from './QueueSidebarContent.css'

type Props = {
  queryRef: PreloadedQuery<QueueSidebarQuery>
  onScroll?: (params: ScrollParams) => void
}

function QueueSidebarContent({queryRef, onScroll}: Props) {
  const [data, refetch] = useRefetchablePreloadedQuery(query, queryRef)
  const doRefetch = useCallback(() => refetch({}), [refetch])
  useSubscribeOnPoolCounters(data, doRefetch)
  const [items, activeItemIndex] = useQueueSidebarItems(data.agentPoolsRest ?? null)
  const searchQuery = useContext(QueueSidebarSearchContext).searchQuery

  if (items.length <= 1) {
    return <SidebarPanelContentNoResults searchQuery={searchQuery} />
  }
  return (
    <QueueSidebarItems
      className={styles.tree}
      items={items}
      activeItemIndex={activeItemIndex}
      onScroll={onScroll}
    />
  )
}
export default QueueSidebarContent
